import React, { FC } from "react";
import { Grid } from "@material-ui/core";
import { DPEmployeeProfile } from "Shared/types/EmployeeProfiles";
import StatusTable from "./StatusTable/StatusTable";
import ContactInfoTable from "./ContactInfoTable/ContactInfoTable";
import IdentifiersTable from "./IdentifiersTable/IdentifiersTable";
import PayGroupsTable from "./PayGroupsTable/PayGroupsTable";
import useStyles from "./styles";

const AccountDetailsGeneral: FC<DPEmployeeProfile> = ({
  id,
  partnerCanceledAt,
  externalIds,
  employee,
  providerAccounts,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.tablesWrapper}>
      <Grid container spacing={10}>
        <Grid item xs={6}>
          <StatusTable partnerCanceledAt={partnerCanceledAt} employee={employee} />
        </Grid>
        <Grid item xs={6}>
          <ContactInfoTable employee={employee} />
        </Grid>
      </Grid>
      <Grid container spacing={10}>
        <Grid item xs={6}>
          <IdentifiersTable externalIds={externalIds} />
        </Grid>
        <Grid item xs={6}>
          <PayGroupsTable
            id={id}
            partnerCanceledAt={partnerCanceledAt}
            providerAccounts={providerAccounts} />
        </Grid>
      </Grid>
    </div>
  );
};

export default AccountDetailsGeneral;
